<!-- ALERT TOAST-->
<p-toast></p-toast>
<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<div class="card" *ngIf="translations">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- TAB VIEW -->
    <p-tabView>
        <!-- TAB PANEL -->
        <p-tabPanel *ngIf="security" [header]="translations.lbl_international_price_list" [selected]="true">

            <!-- MAIN CONTENT -->
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <p-panel>
                        <div class="p-grid" [formGroup]="dataForm">
                            <!-- INFO -->
                            <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12">
                                <!-- INFO -->
                                <div *ngIf="!isMonthAvailable" class="warning-message">
                                    {{monthsMessage}}
                                </div>


                                <!-- INPUT LIST VIGENTE -->
                                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                                    <span>{{translations.lbl_current_list}}</span>
                                    <span class="p-text-bold">{{dataForm.get('data_current_list')?.value}}</span>
                                </div>

                                <!-- INPUT ESTATUS -->
                                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                                    <span>{{translations.lbl_status}}</span>
                                    <span class="p-text-bold">{{dataForm.get('data_status')?.value}}</span>
                                </div>

                                <!-- INPUT TIPO DE CAMBIO US -->
                                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                                    <span>{{translations.lbl_exchange_rate}} (USD)</span>
                                    <span class="p-text-bold">{{dataForm.get('data_exchange_rate')?.value}}</span>
                                </div>

                                <!-- INPUT LIST -->
                                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                                    <div class="subTitle p-col-12 p-md-4">
                                        <span>{{translations.lbl_list}} *</span>
                                    </div>
                                    <div class="p-col-12 p-md-8">
                                        <p-dropdown [options]="priceLst" formControlName="data_list_id"
                                            optionLabel="label" [showClear]="true"
                                            placeholder="{{translations.lbl_select}} {{translations.lbl_list}} {{translations.lbl_id}}"
                                            (onChange)="loadData()"></p-dropdown>
                                    </div>
                                </div>

                                <!-- INPUT LANGUAGE -->
                                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                                    <div class="subTitle p-col-12 p-md-4">
                                        <span>{{translations.lbl_language}}</span>
                                    </div>
                                    <div class="p-col-12 p-md-8">
                                        <p-dropdown [options]="languagesLst" formControlName="data_language"
                                            optionLabel="value" [showClear]="true"
                                            placeholder="{{translations.lbl_select}} {{translations.lbl_language}}"
                                            (onChange)="reloadData()"></p-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-panel>
                </div>
            </div>

            <!-- MAIN TABLE -->
            <p-table *ngIf="priceListInt && security" [exportFilename]="tableName" #dt [value]="priceListInt" [columns]="[
                                                    { field: 'itemId', header: '{{translations.lbl_id}} {{translations.lbl_item}}' },
                                                    { field: 'descri', header: '{{translations.lbl_description}}' },
                                                    { field: 'lastPOPrice', header: '{{translations.lbl_price}} {{translations.lbl_last_purchasing}} MXN' },
                                                    { field: 'usdLastPOPrice', header: '{{translations.lbl_amount}}' },
                                                    { field: 'prc.usdPrice', header: '{{translations.lbl_price}} USD' },
                                                    { field: 'avgCost', header: '{{translations.lbl_average_cost}}' }
                                                    ]" [rows]="200" [paginator]="true"
                [globalFilterFields]="['itemId','descri','conv','lastPOPrice','usdLastPOPrice','prc.usdPrice','avgCost']"
                [(selection)]="selectedPriceListInt" selectionMode="multiple" [rowHover]="true" dataKey="itemId"
                currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
                [showCurrentPageReport]="true" responsive="true" editMode="row">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between">
                        <!-- MAIN TITLE-->
                        <h5 class="p-md-6">{{translations.lbl_list}} {{translations.lbl_item}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </span>
                    </div>

                    <span class="p-input-icon-left">

                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onClickDownloadFile()"
                            class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                            class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                        <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                            (click)="loadData()"></button>

                        <button pButton pRipple type="button"
                            pTooltip="{{translations.lbl_new}} {{translations.lbl_list}}" class="p-m-2 z-5"
                            *ngIf="this.priceListInt != null" (click)="createData()" icon="pi pi-plus" [disabled]="!isMonthAvailable"></button>

                        <button *ngIf="dataForm.get('data_status')?.value === 'N' && this.priceListInt != null" pButton
                            pRipple type="button" pTooltip="{{translations.lbl_approve}} {{translations.lbl_list}}"
                            class="p-button-raised p-button-success p-m-2 z-5" (click)="aproveData()"
                            icon="pi pi-check" [disabled]="!isMonthAvailable"></button>

                        <button pButton pRipple type="button"
                            pTooltip="{{translations.lbl_select}} {{translations.lbl_current_list}}"
                            label="{{translations.lbl_current}}" class="p-button-raised p-button-success p-m-2 z-5"
                            icon="pi pi-arrow-right"
                            *ngIf="dataForm.get('data_status')?.value === 'A' && this.priceListInt != null"
                            (click)="selectUpToDateData()" [disabled]="!isMonthAvailable"></button>
                    </span>
                </ng-template>


                <ng-template pTemplate="header">
                    <!-- Order -->
                    <tr>
                        <th pSortableColumn="itemId">{{translations.lbl_id}} {{translations.lbl_item}}<p-sortIcon
                                field="itemId"></p-sortIcon></th>
                        <th colspan="5" pSortableColumn="descri">{{translations.lbl_description}}<p-sortIcon
                                field="descri"></p-sortIcon></th>
                        <th pSortableColumn="lastPOPrice">{{translations.lbl_price}}
                            {{translations.lbl_last_purchasing}} MXN<p-sortIcon field="lastPOPrice"></p-sortIcon></th>
                        <th pSortableColumn="usdLastPOPrice">$ {{translations.lbl_amount}}
                            {{dataForm.get("data_exchange_rate").value}}
                            <p-sortIcon field="usdLastPOPrice"></p-sortIcon>
                        </th>
                        <th pSortableColumn="prc.usdPrice">{{translations.lbl_price}} USD <p-sortIcon
                                field="prc.usdPrice"></p-sortIcon>
                        </th>
                        <th pSortableColumn="avgCost">{{translations.lbl_average_cost}} <p-sortIcon
                                field="avgCost"></p-sortIcon></th>
                        <th> {{translations.lbl_edit}}</th>
                    </tr>
                    <!-- Filter -->
                    <tr>
                        <th>
                            <p-columnFilter type="text" field="itemId"></p-columnFilter>
                        </th>
                        <th colspan="5">
                            <p-columnFilter type="text" field="descri"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="lastPOPrice"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="usdLastPOPrice"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="prc.usdPrice"></p-columnFilter>
                        </th>

                        <th>
                            <p-columnFilter type="text" field="avgCost"></p-columnFilter>
                        </th>
                        <th> </th>
                    </tr>
                </ng-template>

                <!-- Body -->
                <ng-template pTemplate="body" let-order let-editing="editing" let-ri="rowIndex">
                    <tr *ngIf="order?.itemId == null">
                        <td class="itemCat2" colspan="7">
                            {{ order?.descri ? order.descri : 'S/N' }}
                        </td>
                    </tr>
                    <tr *ngIf="order?.itemId != null" [pSelectableRow]="order" [pEditableRow]="order">
                        <td> {{ order?.itemId ?order.itemId : '0' }}</td>

                        <td style="white-space: normal; word-wrap: break-word;" colspan="5">
                            <mark
                                [ngStyle]="{ 'background-color': order?.itemColor != null ? order?.itemColor : 'transparent' }">
                                {{ order?.descri ? order.descri : 'S/N' }}
                            </mark>
                        </td>

                        <td> {{ order?.lastPOPrice ? (order.lastPOPrice | number: '1.2-2') : '0' }}</td>

                        <td> {{ order?.usdLastPOPrice ?(order.usdLastPOPrice | number: '1.2-2') : '0' }}</td>



                        <td *ngIf="!order.prc">N/A</td>
                        <td *ngIf="order?.prc?.usdPrice != null && order?.prc != null">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-inputNumber [(ngModel)]="order.prc.usdPrice" mode="decimal"
                                        [minFractionDigits]="2" [showButtons]="true">
                                    </p-inputNumber>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span style="font-weight: bold;font-size: 1.35rem;">
                                        {{ order?.prc?.usdPrice ? (order?.prc?.usdPrice | number: '1.2-2') : '0' }}
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td> {{ order?.avgCost ?(order.avgCost | number: '1.2-2') : '0' }}</td>
                        <td style="text-align:center"
                            *ngIf="order?.itm?.itmHiLight !== undefined && (order?.itm?.itmHiLight === 'N' ||  this.dataForm.get('data_status').value.trim() =='N') && isMonthAvailable">
                            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                (click)="onRowEditInit(order)" class="p-button-rounded p-button-text">
                            </button>
                            <button *ngIf="editing && order?.prc?.usdPrice != null && order?.prc != null" pButton
                                pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                (click)="saveUpdatePriceItem(order, ri)"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(order, ri)"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                        </td>

                        <td style="text-align:center" *ngIf="!(order?.itmHiLight === 'N')"></td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_total}} {{priceListInt != null ? priceListInt.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>

        </p-tabPanel>
    </p-tabView>
</div>